import type { User } from '#auth-utils';
import type { HeaderProps } from '~/components/PortalHeader';
import type { Condo, Condominium } from '~/core/entities/condo/Condo';
import type { PropertyFilters } from '~/core/entities/property/filters';
import type { RegionService } from '~~/core/ports/services/RegionService';
import type { InjectionKey } from 'vue';

export const REGION_SERVICE: InjectionKey<RegionService> =
	Symbol('regionService');

export const USER_SYMBOL: InjectionKey<Ref<User | null>> = Symbol('user');
export const USER_OPTION_SYMBOL: InjectionKey<Ref<string | undefined>> =
	Symbol('userOption');

export const HERO_LAYOUT: InjectionKey<{
	headerVariant: Ref<HeaderProps['variant']>;
}> = Symbol('heroLayout');
export const PROPERTIES_LISTING_METHODS: InjectionKey<{
	updateMapFilters: (filters: PropertyFilters) => void;
}> = Symbol('propertiesListing');

export const CONDO_DETAILS: InjectionKey<Ref<Condominium | null>> =
	Symbol('condo');
export const CONDO_CARD: InjectionKey<Condo> = Symbol('condoCard');
